// Client wrappers for the Ghost Members Stripe flow.
//
// The client never sees prices or customer ids — it only sends its Supabase
// JWT to Netlify Functions, which do the work server-side and return a URL
// to redirect to.

import { supabase } from './supabase'

async function callFunction(path, body = {}) {
  const { data: sessionData } = await supabase.auth.getSession()
  const token = sessionData?.session?.access_token
  if (!token) throw new Error('Not signed in')

  const res = await fetch(`/.netlify/functions/${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(data?.error || `Request failed (${res.status})`)
  return data
}

export async function startCheckout() {
  const { url } = await callFunction('create-checkout-session')
  if (!url) throw new Error('No checkout URL')
  window.location.assign(url)
}

export async function openCustomerPortal() {
  const { url } = await callFunction('create-portal-session')
  if (!url) throw new Error('No portal URL')
  window.location.assign(url)
}

// Prepaid lbs stopped being sold on 2026-10-08, so there is no checkout
// here any more — only this read. Two customers are still owed a balance,
// and the account card has to be able to show it.

// Fetch the caller's prepaid balance row (or null if they never had one).
// RLS scopes the query to the current user automatically.
export async function getPrepaidBalance() {
  const { data, error } = await supabase
    .from('prepaid_lbs_balance')
    .select('balance_lbs, total_purchased_lbs, total_consumed_lbs, updated_at')
    .maybeSingle()
  if (error) throw error
  return data || null
}
